import { Outlet } from "react-router-dom";
import { Theme, useTheme } from "@material-ui/core/styles";
import Navbar from "./drawer/Navbar";
import { Box, styled } from "@material-ui/system";
import { CssBaseline, AppBar, Container, Breadcrumbs } from "@material-ui/core";

interface MainStyleProps {
  theme: Theme;
}

const drawerWidth = 280;

const Layout = () => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      {/* header */}
      {/*<Navbar />*/}
      {/* day-selected-drawer */}
      {/* main content */}
      <Main theme={theme}>
        <Outlet />
      </Main>
    </Box>
  );
};

export default Layout;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }: MainStyleProps) => ({
  backgroundPositionY: 'bottom',
  backgroundRepeat: 'no-repeat',
  marginTop: '80px !important',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shorter
  }),
  [theme.breakpoints.up('md')]: {
    width: `100%`
  },
  [theme.breakpoints.down('md')]: {
    width: `100%`,
    padding: '0px'
  },
  [theme.breakpoints.down('sm')]: {
    width: `100%`,
    padding: '0px',
  }
}));
